import { makeStyles } from '@material-ui/core/styles';

import { neutral, red } from 'shared/styles/colors';
import { MOZART_COMPLAINT_REASON } from 'features/mozart-notifications/domain';

export default makeStyles({
  card: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    backgroundColor: neutral.white,
    borderBottom: `1px solid ${neutral[20]}`,
    '&[data-seen="true"]': {
      backgroundColor: neutral[10],
      borderBottom: `1px solid ${neutral[30]}`,
    },
    [`&[data-complaint-reason="${MOZART_COMPLAINT_REASON.DEFECT_GROUNDED}"][data-seen="false"]`]: {
      borderRadius: '0.25rem',
      border: `2px solid ${red[50]}`,
    },
  },

  main: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  storeName: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: neutral[60],
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[100],
  },
  checkMark: {
    height: '0.5rem',
    width: '0.5rem',
    borderRadius: '50%',
    backgroundColor: red[50],
    '[data-seen="true"] &': {
      display: 'none',
    },
  },
  description: {
    display: '-webkit-box',
    overflow: 'hidden',
    textWrapMode: 'wrap',
    textWrapStyle: 'pretty',
    // whiteSpace: 'pre-wrap',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: neutral[100],
  },
  complaintImage: {
    height: '3rem',
    width: '3rem',
    marginBottom: '0.5rem',
    objectFit: 'cover',
    borderRadius: '0.25rem',
    '[data-seen="true"] &': {
      filter: 'grayscale(100%)',
    },
  },

  footer: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btn: {
    minWidth: '10rem',
    padding: '0.5rem 1.5rem',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[20],
    boxShadow: 'none',
    borderRadius: '0.5rem',
    backgroundColor: neutral[90],
    '&:hover': {
      boxShadow: 'none',
      color: neutral.white,
      backgroundColor: neutral[70],
    },
    '[data-seen="true"] &': {
      color: neutral[80],
      backgroundColor: neutral.white,
      border: `1px solid ${neutral[20]}`,
      '&:hover': {
        boxShadow: 'none',
        color: neutral[90],
        backgroundColor: neutral[20],
        border: `1px solid ${neutral[30]}`,
      },
    },
  },
  alertChip: {
    padding: '0.25rem 0.5rem',
    display: 'none',
    gap: '0.25rem',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    whiteSpace: 'nowrap',
    color: neutral['10'],
    borderRadius: '1.25rem',
    backgroundColor: red[60],
    '& svg': {
      marginBottom: '0.125rem',
      fontSize: '1rem',
    },
    [`[data-complaint-reason="${MOZART_COMPLAINT_REASON.DEFECT_GROUNDED}"][data-seen="false"] &`]: {
      display: 'flex',
    },
  },
  createdAt: {
    fontWeight: 400,
    fontSize: '0.625rem',
    lineHeight: '1rem',
    color: neutral[60],
    textAlign: 'right',
  },
});
